import { render, staticRenderFns } from "./CreateRule.vue?vue&type=template&id=02c2afd4&scoped=true"
import script from "./CreateRule.vue?vue&type=script&lang=js"
export * from "./CreateRule.vue?vue&type=script&lang=js"
import style0 from "./CreateRule.vue?vue&type=style&index=0&id=02c2afd4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c2afd4",
  null
  
)

export default component.exports